<template>
    <div>
        <div class="preview-opration">
            <el-input v-model="queryParams.coinType" placeholder="请输币种" style="width: 300px"></el-input>
            <el-button style="margin-left: 30px" type="primary" @click="searchCoin">搜索
            </el-button>
            <el-button style="float: right" type="danger" @click="syncLabelToCoin">同步币种标签到币种
            </el-button>
        </div>
        <div class="recommend-coin-list">
            <el-table class="recommend-coin-table" border
                      :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="coinList" :row-key="() => Math.random()">
                <el-table-column label="币种">
                    <template slot-scope="scope">
                        <div class="logo">
                            <img :src="scope.row.logo"/>
                            {{ scope.row.coinType }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="包含标签" min-width="300px">
                    <template slot-scope="scope">
                        <el-tag type="info" style="margin-right: 5px" v-for="item in scope.row.labelDetails"
                                :key="item.id">{{item.labelName}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="updateLabelDialog(scope.row)">设置标签
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="选择标签" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleLabelClick"
                             style="width: 80%;display: inline-block">
                        <el-tab-pane v-for="item in labelArry" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
                    </el-tabs>
                </div>
                <div style="margin-top: 20px">
                    <el-input placeholder="请输入名称" v-model="query.labelName" prefix-icon="el-icon-search"
                              style="width: 80%"></el-input>
                    <el-button style="margin-left: 10px" type="danger" @click="searchDialogLabel">搜索</el-button>
                </div>
                <div style="margin-top: 20px;margin-bottom: 50px;max-height: 400px">
                    <el-tag style="margin-right: 5px;cursor: default;margin-bottom: 5px" v-for="item in labelListDialog"
                            :key="item.id"
                            @click.native="chooseLabel(item)" :type="getTagType(item.id)">
                        {{item.labelName}}
                    </el-tag>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="updateLabel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from '../api';
    import {LABELTYPE} from "../common/constants";

    export default {
        name: 'RelevantRecommend',
        data() {
            return {
                coinList: [], //推荐位列表
                total: 0, //总条数
                queryParams: { //查询参数
                    coinType: "",
                    page: 1,
                    size: 10
                },
                query: { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                },
                dialogVisible: false, //对话框是否显示
                activeName: "PRODUCT_LABEL", //激活的tab
                labelListDialog: [], //对话框选择标签数据列表
                dynamicTags: [], //选择的标签id
                currCoinId: "", //当前操作的币种id
                labelArry: LABELTYPE
            };
        },

        methods: {
            searchCoin() {
                this.queryParams.page = 1;
                this.getCoinList(this.queryParams);
            },
            searchDialogLabel() {
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            getCoinList(query) {
                api.getCoinList(query).then(({data}) => {
                    this.coinList = data.records;
                    this.total = data.total;
                });
            },
            getDialogLabelList(query) {
                api.getLabelList(query).then(({data}) => {
                    this.labelListDialog = data.records;
                });
            },
            handleLabelClick() {
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            chooseLabel(item) {
                let id = item.id + "";
                this.dynamicTags.indexOf(id) == -1 ? this.dynamicTags.push(id) : this.dynamicTags.splice(this.dynamicTags.indexOf(id), 1);
            },
            getTagType(id) {
                id = id + "";
                return this.dynamicTags.indexOf(id) == -1 ? "info" : "danger";
            },
            updateLabelDialog(row) {
                row.labelDetails.forEach(item => {
                    this.dynamicTags.push(item.id + "");
                });
                this.currCoinId = row.id;
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
                this.dialogVisible = true;
            },
            updateLabel() {
                api.updateCoinabel({coinId: this.currCoinId, labelIds: this.dynamicTags.join(",")}).then(({data}) => {
                    this.$message.success('修改成功！');
                    this.dialogVisible = false;
                    this.getCoinList(this.queryParams);
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getCoinList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getCoinList(this.queryParams);
            },
            clearData() {
                this.dynamicTags = [];
                this.query = { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                };
                this.activeName = "PRODUCT_LABEL"; //激活的tab
                this.labelListDialog = []; //对话框选择标签数据列表
                this.dynamicTags = []; //选择的标签id
                this.currCoinId = ""; //当前操作的币种id
            },
            syncLabelToCoin(){
                this.$confirm('确认同步币种标签到币种吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.syncLabelToCoin().then(({data}) => {
                        this.$message.success('同步成功！');
                        this.searchCoin();
                    });
                }).catch(() => {
                });
            }
        },
        created() {
            this.getCoinList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .recommend-coin-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .recommend-coin-table {
            margin-top: 30px;

            .logo {
                display: flex;
                align-items: center;

                img {
                    margin-right: 8px;
                    width: 44px;
                    height: 44px;
                    border: 0;
                }
            }
        }
    }
</style>